<template>
  <div class="index-box">
    <div style="margin-bottom: 0.5rem">
      <p class="text-title">客户营收管理</p>
    </div>
    <a-row :gutter="8">
      <a-col :span="10">
        <!-- 每月绩效完成情况 -->
        <SellerMonthlyTargetCompletion :formState="props.formState"/>
        <!-- 每月绩效完成情况 -->
        <RegionTargetCompletion :formState="props.formState"/>
      </a-col>
      <a-col :span="4">
        <!-- 年度预算目标完成率 -->
        <RegionRevenueManagementGauge appId="cos_fbu" title="年度预算目标完成率" :value="keyData.yearBudget"/>
        <div style="margin-top: 8px;margin-bottom: 8px">
          <!-- 当月预算目标完成率 -->
          <RegionRevenueManagementGauge appId="cos_fbu" title="当月预算目标完成率" :value="keyData.monthBudget"/>
        </div>
        <div style="margin-bottom: 8px">
          <!-- 年度利润目标完成率 -->
          <RegionRevenueManagementGauge appId="cos_fbu" title="年度利润目标完成率" :value="keyData.yearProfit"/>
        </div>
        <!-- 当月利润目标完成率 -->
        <RegionRevenueManagementGauge appId="cos_fbu" title="当月利润目标完成率" :value="keyData.monthProfit"/>
      </a-col>
      <a-col :span="10">
        <a-row :gutter="8">
          <a-col :span="8">
            <div class="rightContainer">
              <div class="rightTotal">
                <span class="total-label">当月总收入（万元）</span>
                <span class="total-number center-rate">{{ keyData.salesAmountTotal }}</span>
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="rightContainer">
              <div class="rightTotal">
                <span class="total-label">当月新客收入（万元）</span>
                <span class="total-number center-rate">{{ keyData.salesAmount }}</span>
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="rightContainer">
              <div class="rightTotal">
                <span class="total-label">当月老客收入（万元）</span>
                <span class="total-number center-rate">{{ keyData.oldSalesAmount }}</span>
              </div>
            </div>
          </a-col>
        </a-row>
        <!-- 新激活客户数 -->
        <RegionNewActivatedCustomerCount :formState="props.formState"/>
        <!-- 新激活客户月销售额 -->
        <RegionTargetCompletionList :formState="props.formState"/>
      </a-col>
    </a-row>
  </div>
</template>
<script setup lang="ts">
import { onMounted, PropType, ref, watch } from 'vue'
import SellerMonthlyTargetCompletion
  from '@/views/gucangSales/dataBoard/region/componects/SellerMonthlyTargetCompletion.vue'
import RegionTargetCompletion from '@/views/gucangSales/dataBoard/region/componects/RegionTargetCompletion.vue'
import RegionNewActivatedCustomerCount from '@/views/gucangSales/dataBoard/region/componects/RegionNewActivatedCustomerCount.vue'
import { getRegionCustomerRevenueDataBoard } from '@/api/gucangSales/regionDataBoard'
import RegionRevenueManagementGauge
  from '@/views/gucangSales/dataBoard/region/componects/RegionRevenueManagementGauge.vue'
import RegionTargetCompletionList from '@/views/gucangSales/dataBoard/region/componects/RegionTargetCompletionList.vue'

const props = defineProps({
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  formState: {
    type: Object as PropType<Object>
  }
})
const keyData = ref<any>({})
onMounted(() => {
  getCustomerRevenueDashData()
})
watch(
  () => props.formState,
  (val) => {
    getCustomerRevenueDashData()
  }
)
const getCustomerRevenueDashData = () => {
  getRegionCustomerRevenueDataBoard(props.formState).then((res: any) => {
    const { data } = res
    // 当月总收入
    keyData.value.salesAmountTotal = data?.salesAmountTotal ?? 0
    // 当月新客收入
    keyData.value.salesAmount = data?.salesAmount ?? 0
    // 当月老客收入
    keyData.value.oldSalesAmount = data?.oldSalesAmount ?? 0
    // 当月预算目标完成率
    const monthBudgetCompletionRateData = data?.monthBudgetCompletionRate
    if (monthBudgetCompletionRateData) {
      keyData.value.monthBudget = {
        rateValue: monthBudgetCompletionRateData.budgetTargetValue ? Number((((monthBudgetCompletionRateData.budgetCompletionValue ?? 0) / monthBudgetCompletionRateData.budgetTargetValue) * 100).toFixed(2)) : 0,
        targetValue: monthBudgetCompletionRateData.budgetTargetValue,
        completeValue: monthBudgetCompletionRateData.budgetCompletionValue
      }
    }

    // 年度预算目标完成率
    const yearBudgetCompletionRateData = data?.yearBudgetCompletionRate
    if (yearBudgetCompletionRateData) {
      keyData.value.yearBudget = {
        rateValue: yearBudgetCompletionRateData.budgetTargetValue ? Number((((yearBudgetCompletionRateData.budgetCompletionValue ?? 0) / yearBudgetCompletionRateData.budgetTargetValue) * 100).toFixed(2)) : 0,
        targetValue: yearBudgetCompletionRateData.budgetTargetValue,
        completeValue: yearBudgetCompletionRateData.budgetCompletionValue
      }
    }

    // 当月利润目标完成率
    const monthProfitCompletionRateData = data?.monthProfitCompletionRate
    if (monthProfitCompletionRateData) {
      keyData.value.monthProfit = {
        rateValue: monthProfitCompletionRateData.profitTargetValue ? Number((((monthProfitCompletionRateData.profitCompletionValue ?? 0) / monthProfitCompletionRateData.profitTargetValue) * 100).toFixed(2)) : 0,
        targetValue: monthProfitCompletionRateData.profitTargetValue,
        completeValue: monthProfitCompletionRateData.profitCompletionValue
      }
    }

    // 年度利润目标完成率
    const yearProfitCompletionRateData = data?.yearProfitCompletionRate
    if (yearProfitCompletionRateData) {
      keyData.value.yearProfit = {
        rateValue: yearProfitCompletionRateData.profitTargetValue ? Number((((yearProfitCompletionRateData.profitCompletionValue ?? 0) / yearProfitCompletionRateData.profitTargetValue) * 100).toFixed(2)) : 0,
        targetValue: yearProfitCompletionRateData.profitTargetValue,
        completeValue: yearProfitCompletionRateData.profitCompletionValue
      }
    }
    // matchItem.targetValueTotal ? Number((((matchItem.completionValueTotal ?? 0) / matchItem.targetValueTotal) * 100).toFixed(2)) : 0
  })
}
</script>
<script lang="ts">
export default {
  name: 'Tab3'
}
</script>
<style scoped lang="scss">
.index-box {
  background: rgb(249, 249, 255);
  padding: 10px;
}

.text-title {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}

.rightContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 20px 20px 20px;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  height: 132px;
  margin-bottom: 8px;
}

.rightTotal {
  font-size: 20px;
  width: 100%;
  margin-bottom: 20px;
}

.total-label {
  font-size: 14px;
  color: #5b687d;
}

.total-number {
  font-family: Lato, sans-serif;
  display: block;
  font-size: 32px;
  color: #26292e;
  letter-spacing: 1px;
  margin-top: 10px;
  font-weight: 800;
  line-height: 36px;
  text-align: left;
}

.total-number.center-rate {
  text-align: center;
}
</style>
